import { render, staticRenderFns } from "./UserBio.vue?vue&type=template&id=54e5ee99"
import script from "./UserBio.vue?vue&type=script&lang=js"
export * from "./UserBio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports